import { render, staticRenderFns } from "./MobileCallDialog.vue?vue&type=template&id=16fd11eb&"
import script from "./MobileCallDialog.vue?vue&type=script&lang=js&"
export * from "./MobileCallDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports